import React from 'react';
import PropTypes from 'prop-types';

import { FaPencilAlt as PencilIcon } from 'react-icons/fa';

type ConnectionSettingsAdminColumnRendererProps = {
  showModalForEdit: Function,
  value: {
    connName?: string | null,
  },
};


const ConnectionSettingsAdminColumnRendererFactory = ({ showModalForEdit }: any) => {
  const ConnectionSettingsAdminColumnRenderer: React.FC<ConnectionSettingsAdminColumnRendererProps> = ({
    value,
  }) => {
    const onEditClick = () => {
      showModalForEdit(value);
    };
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Connection Settings"
          onClick={onEditClick} // eslint-disable-line react/jsx-no-bind
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  };

  ConnectionSettingsAdminColumnRenderer.propTypes = {
    value: PropTypes.shape({
      connName: PropTypes.string,
    }).isRequired,
    showModalForEdit: PropTypes.func.isRequired,
  };
  return ConnectionSettingsAdminColumnRenderer;
};

export default ConnectionSettingsAdminColumnRendererFactory;
